import React from "react";
import UploadImage from "components/util/editor-uploader";
import buttonTheme from "css/themes/Buttons.css";
import { Button } from "react-toolbox/lib/button";
import Validator from "util/form-validator";
import Field from "visual-components/util/inputs/field";

const validations = {
  ctaMessageText: [Validator.required],
  ctaURL: [Validator.required],
  ctaActionText: [Validator.required],
};

/**
 * CTA editor component for Small Image+Text+Button type.
 * Combines headline text, CTA link, button text, and a small image upload.
 *
 * @param {Object} props - Component props
 * @param {Object} props.dataModel - The CTA data model containing form values
 * @param {Object} props.formModel - The form validation model
 * @param {Function} props.updateAttr - Function to update CTA attributes
 * @return {import("react").ReactElement} The CTA editor component
 */
export default function CtaButtonImage(props) {
  const { dataModel: cta, ...otherProps } = props;

  /**
   * Handles image upload success by updating the ctaImage in the store
   * @param {string} src - The uploaded image URL
   */
  const updateCtaImage = (src) => {
    store.dispatch({
      model: "ctaModel",
      type: "UPDATE_ATTR",
      data: {
        ctaImage: src,
      },
    });
  };

  return (
    <div>
      <Field
        {...otherProps}
        dataModel={cta}
        attrName="ctaMessageText"
        label="Headline Message"
        placeholder="Headline Message"
        validations={validations.ctaMessageText}
      />

      <Field
        {...otherProps}
        dataModel={cta}
        attrName="ctaUrl"
        label="Custom CTA Link"
        placeholder="http://www.companysite.com/promo"
        validations={validations.ctaURL}
      />

      <Field
        {...otherProps}
        dataModel={cta}
        attrName="ctaActionText"
        label="Button Text"
        placeholder="Button Text"
        validations={validations.ctaActionText}
      />

      <div className="-mt-2 mr-3 inline-block w-28">
        <UploadImage
          action={`/partnership-cta-image/${cta.id}`}
          src={cta.ctaImage}
          success={updateCtaImage}
          name="upload-cta-image"
          acceptedFiles="image/jpeg,image/png,image/gif"
        >
          <Button
            theme={buttonTheme}
            className={`${buttonTheme.greenButton} ${buttonTheme.noMargin}`}
            label="Upload Image"
            raised
          />
        </UploadImage>
      </div>
    </div>
  );
}
